fragment TestimonialWithVariedBackgroundFragment on testimonialWithVariedBackground_Entry {
  typeHandle
  heading
  backgroundBlack
  slides: testimonialSlides {
    ... on testimonialSlidesBlock_Entry {
      id
      body
      authorName
      authorImage {
        url
        title
      }
    }
  }
}
